import styled from '@emotion/styled';
import GlassMorphic from './../../../../assets/glassmorphic.svg';

const GlassMorphicStyled = styled(GlassMorphic)`
  background-image: conic-gradient(
    from 192deg at 46.5% 42.58%,
    rgba(97, 158, 251, 0.24) 111.60000085830688deg,
    rgba(176, 207, 251, 0.24) 180deg
  );
  filter: blur(95px);
  min-width: 435px;
  width: 100%;
  height: 100%;
  transform: rotate(-45.864deg);
  @media (min-width: 1024px) {
  }
`;
export const GlassEffectBackground = () => {
  return <GlassMorphicStyled />;
};
